// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-k_gx","advertDetailContactGroup__header":"c-k_gy","advertDetailContactGroup__value":"c-k_gz"};